module.exports = __webpack_public_path__ + "static/img/未入库@4x.e26fa796.png";